module.exports = __webpack_public_path__ + "img/breath_yellow.47dfe624.png";